(function () {
  'use strict';

  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var iconMenu = document.querySelector('[data-icon-menu]');
    var iconClose = document.querySelector('[data-icon-close]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('is-open');
      if (iconMenu) iconMenu.classList.toggle('dgtl-hidden', isOpen);
      if (iconClose) iconClose.classList.toggle('dgtl-hidden', !isOpen);
    });
  }

  function initTimestamp() {
    var el = document.querySelector('[data-live-timestamp]');
    if (!el) return;
    function update() {
      el.textContent = new Date().toISOString().replace('T', ' ').substring(0, 19) + ' UTC';
    }
    update();
    setInterval(update, 1000);
  }

  function initProductGallery() {
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    document.querySelectorAll('[data-thumb-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-thumb-src');
        if (src) main.src = src;
        document.querySelectorAll('.dgtl-product-gallery__thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });
  }

  function initQuantity() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var input = form.querySelector('[data-qty-input]');
    var display = form.querySelector('[data-qty-display]');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (!input) return;

    function setQty(n) {
      var val = Math.max(1, n);
      input.value = val;
      if (display) display.textContent = val;
    }
    if (minus) minus.addEventListener('click', function () { setQty(parseInt(input.value, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(parseInt(input.value, 10) + 1); });
  }

  function initVariants() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var product = JSON.parse(jsonEl.textContent);
    var variantInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-product-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var selected = {};

    section.querySelectorAll('[data-option-name]').forEach(function (btn) {
      if (btn.classList.contains('is-selected')) {
        selected[btn.getAttribute('data-option-name')] = btn.getAttribute('data-option-value');
      }
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-option-name');
        var value = btn.getAttribute('data-option-value');
        selected[name] = value;
        section.querySelectorAll('[data-option-name="' + name + '"]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        updateVariant();
      });
    });

    function updateVariant() {
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[product.options[i]] === opt;
        });
      });
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) {
        var html = '<span class="dgtl-product-info__price">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="dgtl-product-info__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'ADD TO BAG' : 'OUT OF STOCK';
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    }
  }

  function initOverlayTime() {
    var el = document.querySelector('[data-overlay-time]');
    if (!el) return;
    function update() {
      el.textContent = new Date().toISOString().replace('T', ' ').substring(0, 19) + ' UTC';
    }
    update();
    setInterval(update, 1000);
  }

  function getYouTubeId(url) {
    var patterns = [
      /youtu\.be\/([^?&#]+)/,
      /youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)([^?&#]+)/,
      /[?&]v=([^?&#]+)/
    ];
    for (var i = 0; i < patterns.length; i++) {
      var match = url.match(patterns[i]);
      if (match) return match[1];
    }
    return null;
  }

  function getVimeoId(url) {
    var match = url.match(/(?:vimeo\.com\/(?:video\/)?|player\.vimeo\.com\/video\/)(\d+)/);
    return match ? match[1] : null;
  }

  function embedVideoUrl(url) {
    if (!url || !url.trim()) {
      return '<p style="color:#fff;text-align:center;padding:2rem;font-family:monospace;font-size:0.875rem;">No video linked yet.<br><br>Add a YouTube, Vimeo, or MP4 link in Theme editor → Video gallery → Video item.</p>';
    }

    url = url.trim();

    if (url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be') !== -1) {
      var ytId = getYouTubeId(url);
      if (ytId) {
        return '<iframe src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&mute=1&rel=0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen title="Video"></iframe>';
      }
    }

    if (url.indexOf('vimeo.com') !== -1 || url.indexOf('player.vimeo.com') !== -1) {
      var vimeoId = getVimeoId(url);
      if (vimeoId) {
        return '<iframe src="https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&muted=1" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video"></iframe>';
      }
    }

    if (/\.(mp4|webm|mov)(\?|$)/i.test(url) || url.indexOf('cdn.shopify.com') !== -1) {
      return '<video src="' + url + '" class="dgtl-relic-video" controls autoplay muted playsinline data-relic-video></video>';
    }

    return '<p style="color:#fff;text-align:center;padding:2rem;font-family:monospace;font-size:0.875rem;">Could not play this link.<br><br>Use a YouTube, Vimeo, or direct .mp4 URL.</p>';
  }

  function requestFullscreen(el) {
    if (!el) return Promise.resolve();
    var fn = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen;
    if (!fn) return Promise.resolve();
    try {
      return Promise.resolve(fn.call(el)).catch(function () {});
    } catch (err) {
      return Promise.resolve();
    }
  }

  function exitDocumentFullscreen() {
    var doc = document;
    var el = doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement;
    if (!el) return;
    var fn = doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    if (fn) fn.call(doc);
  }

  function enterRelicFullscreen(lightbox, player) {
    if (!lightbox || !player) return;
    var video = player.querySelector('[data-relic-video]');
    if (video) {
      function tryVideoFullscreen() {
        if (video.webkitEnterFullscreen) {
          try {
            video.webkitEnterFullscreen();
            return;
          } catch (err) { /* fall through */ }
        }
        requestFullscreen(video).then(function () {
          if (!document.fullscreenElement && !document.webkitFullscreenElement) {
            requestFullscreen(lightbox);
          }
        });
      }
      if (video.readyState >= 1) {
        tryVideoFullscreen();
      } else {
        video.addEventListener('loadeddata', tryVideoFullscreen, { once: true });
      }
      return;
    }
    requestFullscreen(lightbox);
  }

  function initVideoGallery() {
    var gallery = document.querySelector('[data-video-gallery]');
    if (!gallery) return;

    var filter = gallery.querySelector('[data-video-filter]');
    var search = gallery.querySelector('[data-video-search]');
    var empty = gallery.querySelector('[data-video-empty]');
    var count = gallery.querySelector('[data-video-count]');
    var lightbox = gallery.querySelector('[data-video-lightbox]');
    var player = gallery.querySelector('[data-lightbox-player]');

    function applyFilter() {
      var cat = filter ? filter.value : 'all';
      var query = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;

      gallery.querySelectorAll('[data-video-card]').forEach(function (card) {
        var matchCat = cat === 'all' || card.getAttribute('data-category') === cat;
        var title = card.getAttribute('data-title') || '';
        var matchSearch = !query || title.indexOf(query) !== -1;
        var show = matchCat && matchSearch;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });

      if (count) count.textContent = String(visible);
      if (empty) empty.classList.toggle('dgtl-hidden', visible > 0);
    }

    if (filter) filter.addEventListener('change', applyFilter);
    if (search) search.addEventListener('input', applyFilter);

    gallery.querySelectorAll('[data-video-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!lightbox || !player) return;
        var idx = btn.getAttribute('data-index');
        var title = btn.getAttribute('data-title');
        var category = btn.getAttribute('data-category');
        var year = btn.getAttribute('data-year');
        var url = btn.getAttribute('data-video-url');
        var idEl = lightbox.querySelector('[data-lightbox-id]');
        var titleEl = lightbox.querySelector('[data-lightbox-title]');
        var subEl = lightbox.querySelector('[data-lightbox-sub]');
        if (idEl) idEl.textContent = '[RELIC-' + String(idx).padStart(3, '0') + ']';
        if (titleEl) titleEl.textContent = title;
        if (subEl) subEl.textContent = category + ' | ' + year;
        player.innerHTML = embedVideoUrl(url);
        lightbox.classList.remove('dgtl-hidden');
        document.body.style.overflow = 'hidden';
        enterRelicFullscreen(lightbox, player);
      });
    });

    function closeLightbox() {
      if (!lightbox || !player) return;
      exitDocumentFullscreen();
      lightbox.classList.add('dgtl-hidden');
      player.innerHTML = '';
      document.body.style.overflow = '';
    }

    var closeBtn = gallery.querySelector('[data-video-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox && !lightbox.classList.contains('dgtl-hidden')) closeLightbox();
    });

    applyFilter();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initTimestamp();
    initOverlayTime();
    initProductGallery();
    initQuantity();
    initVariants();
    initVideoGallery();
  });
})();
